import { useNavigate } from "react-router-dom";
import LogoNoSign from "../../../../assets/logo-no-sign.png";
import LogoText from "../../../../assets/logo-text.png";
import CustomButton from "../../buttons/CustomButton";
import styles from "./styles/PublicHeader.module.css";

type NavLink = {
  label: string;
  to?: string;
  onClick?: () => void;
};

type Props = {
  links?: NavLink[];
  onLogoClick?: () => void;
};

const PublicHeader = ({ links = [], onLogoClick }: Props) => {
  const navigate = useNavigate();

  const handleLink = (link: NavLink) => {
    if (link.onClick) {
      link.onClick();
    } else if (link.to) {
      navigate(link.to);
    }
  };

  return (
    <div className={styles.header}>
      <div className={styles.logoContainer} onClick={onLogoClick ?? (() => navigate("/"))}>
        <img className={styles.logo} src={LogoNoSign} alt="Xeniapps" height={50} />
        <img className={styles.logoText} src={LogoText} alt="Xeniapps" />
      </div>
      {links.length > 0 && (
        <div className={styles.buttonContainer}>
          {links.map((link) => (
            <CustomButton
              key={link.label}
              text={link.label}
              onClick={() => handleLink(link)}
              type="link"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PublicHeader;
